import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";

import { Avatar, Button, IconButton } from "@toddle-edu/ds-web";
import {
  DownloadCloudOutlined,
  ProgressReportOutlined,
} from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";

import classes from "./SharedReportCard.scss";

const SharedReportCard = props => {
  const {
    reportId,
    reportTitle,
    publishedAt,
    onViewClick,
    onDownloadClick,
  } = props;

  const { t } = useI18n([]);
  const formattedDate = publishedAt
    ? moment(publishedAt).format(DATE_TIME_CONSTANTS.Do_MMM_YYYY_NO_COMMA)
    : "";

  return (
    <article
      className={classes.cardContainer}
      data-test-id="sharedReportCard-container"
    >
      <div className={classes.leftContent}>
        <Avatar
          id={reportId}
          shape="square"
          iconType="icon"
          size="medium"
          icon={<ProgressReportOutlined />}
        />
        <div className={classes.textContent}>
          <span className={classNames("text-label", classes.reportName)}>
            {reportTitle}
          </span>
          <div className={classes.metaRow}>
            {formattedDate && (
              <span className={classNames("text-body-s", classes.metaText)}>
                {t("progressReport:shared_on_date", {
                  date: formattedDate,
                })}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={classes.actionContainer}>
        <LinkWithTooltip
          tooltip={t("common:download")}
          placement="bottom"
          href={null}
        >
          <IconButton
            icon={<DownloadCloudOutlined />}
            variant="neutral"
            type="plain"
            size="medium"
            onClick={onDownloadClick}
            ariaLabel={t("common:download")}
            testId="sharedReportCard-downloadButton"
          />
        </LinkWithTooltip>
        <Button
          variant="neutral"
          type="outlined"
          size="medium"
          onClick={onViewClick}
          testId="sharedReportCard-viewReportButton"
        >
          {t("progressReport:view_report")}
        </Button>
      </div>
    </article>
  );
};

SharedReportCard.propTypes = {
  reportId: PropTypes.string.isRequired,
  reportTitle: PropTypes.string.isRequired,
  publishedAt: PropTypes.string,
  onViewClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
};

SharedReportCard.defaultProps = {
  publishedAt: "",
};

export default SharedReportCard;
